import { Component, Output, Input , EventEmitter, Injectable, ChangeDetectorRef} from '@angular/core';
import { CDN_BASE_URL } from "src/constants/param-constants";
@Injectable({ providedIn: 'root' })
@Component({
  selector: 'upsell-product-box-tbyb',
  templateUrl: 'upsell-product-box-tbyb.html',
  styleUrls: ['upsell-product-box-tbyb.scss'],
})
export class UpsellProductBoxTBYBComponent {
  @Input() productName: string = '';
  @Input() productBoxTitle: string = '';
  @Input() productBoxSubtitle: string = '';
  @Input() image: string = 'assets/img/No-Image-Available.jpg';
  @Input() imageAlt: string = '';
  @Input() regularPrice: number = 0;
  @Input() instantSavings: number = 0;
  @Input() productPercent: number = 0;
  @Input() totalProductsSummary: number = 0;
  @Input() yourPrice: number = 0;
  @Input() currentUpsellTax: number = 0;
  @Input() currency: string = 'USD';  // TOUC-14710
  @Input() currencySymbol: string = '$';
  @Input() officialCurrency: string = 'USD';
  @Input() braintreeCurrencyConversion: number = 1;

  @Input() buttonYesText: string = `Yes I want this special added to my order`;
  @Input() buttonNoText: string = `No thanks, I understand that I won't see this offer again`;
  @Input() productBoxCTA: boolean = false;

  @Input() isAmazon: boolean = false;
  @Input() isPlaceOrder: boolean = true;
  @Input() showImage: boolean = true;

  @Input() regularText: string = 'Regular Price';
  @Input() instantSavingsText: string = 'Instant Savings';
  @Input() yourPriceText: string = 'Your Price';
  @Input() reviewCount: number = 0;
  @Input() mbgDays: number = 60;
  @Output() amazonPaymentEmitter: EventEmitter<void> = new EventEmitter();
  @Output() eventEmitter: EventEmitter<boolean> = new EventEmitter();


  constructor(private cdr: ChangeDetectorRef) {}

  nextPage(buttonValue: boolean) {
    this.eventEmitter.emit(buttonValue);
  }

  payWithAmazon() {
    this.amazonPaymentEmitter.emit();
  }

  isModalOpen: boolean = false;

  get mbgBadgeLink(): string {
    return `${CDN_BASE_URL}/images/BHMD-${this.mbgDays}Day-Badge.png`;
  }

  openModal() {
    this.isModalOpen = true;
    this.cdr.detectChanges();
  }

  closeModal() {
    this.isModalOpen = false;
    setTimeout(() => this.cdr.detectChanges(), 0);
  }

  onModalClick(event: Event) {
    // Close modal if clicking on backdrop, prevent closing if clicking on content
    if (event.target === event.currentTarget) {
      this.closeModal();
    }
  }
}
